var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 19C38 8.50659 29.4934 0 19 0C8.50659 0 0 8.50659 0 19C0 29.4934 8.50659 38 19 38C29.4934 38 38 29.4934 38 19Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.2992 19.2161C28.2992 18.5425 28.2388 17.8948 28.1265 17.2729H19.1792V20.9477H24.2919C24.0717 22.1352 23.4024 23.1414 22.3963 23.815V26.1987H25.4665C27.2629 24.5448 28.2992 22.1093 28.2992 19.2161Z",
    fill: "#4285F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1771 28.5002C21.7421 28.5002 23.8925 27.6495 25.4644 26.1986L22.3941 23.815C21.5434 24.385 20.4552 24.7218 19.1771 24.7218C16.7027 24.7218 14.6084 23.0506 13.8614 20.8052H10.6875V23.2665C12.2507 26.3713 15.4634 28.5002 19.1771 28.5002Z",
    fill: "#34A853"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8635 20.8048C13.6735 20.2348 13.5656 19.6259 13.5656 18.9998C13.5656 18.3736 13.6735 17.7648 13.8635 17.1948V14.7334H10.6897C10.0462 16.0159 9.6792 17.4668 9.6792 18.9998C9.6792 20.5327 10.0462 21.9836 10.6897 23.2661L13.8635 20.8048Z",
    fill: "#FBBC05"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1771 13.2784C20.5718 13.2784 21.8241 13.7577 22.8087 14.6991L25.5334 11.9743C23.8882 10.4414 21.7378 9.5 19.1771 9.5C15.4634 9.5 12.2507 11.6289 10.6875 14.7336L13.8614 17.195C14.6084 14.9496 16.7027 13.2784 19.1771 13.2784Z",
    fill: "#EA4335"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/Google.e5cdef3d7075c9f92ac5f6e92bd91d3c.svg";
export { ForwardRef as ReactComponent };